/**
 * Calculates the display household number by adding 1 to the raw household number.
 * Returns empty string if the input is null, undefined, empty string, or not a valid number.
 * 
 * @param rawHouseholdNumber - The raw household number from the API
 * @returns The display household number (raw + 1) or empty string
 */
export const calculateHouseholdNumber = (rawHouseholdNumber: string | number | null | undefined): string | number => {
    return rawHouseholdNumber != null && rawHouseholdNumber !== '' && !isNaN(Number(rawHouseholdNumber))
        ? Number(rawHouseholdNumber) + 1 
        : '';
};

/**
 * Maps API citizenship/VLP status strings to i18n message ids for the
 * Household Members worksheet column.
 * Unknown values return null so callers can fall back to the raw API string.
 */
export const getCitizenshipOrVlpStatusMessageId = (
    status: string | null | undefined,
): string | null => {
    if (status == null || status === '') {
        return null;
    }

    const normalized = status.trim().toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ');

    switch (normalized) {
        case 'citizen':
        case 'us citizen':
        case 'u.s. citizen':
        case 'u.s citizen':
            return 'application.eligibility.member.citizenship.status.us.citizen';
        case 'eligible non citizen':
        case 'eligible noncitizen':
            return 'application.eligibility.member.citizenship.status.eligible.noncitizen';
        case 'lawfully present':
            return 'application.eligibility.member.citizenship.status.lawfully.present';
        case 'not lawfully present':
            return 'application.eligibility.member.citizenship.status.not.lawfully.present';
        default:
            return null;
    }
};

